import script from "./VehicleRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleRequest.vue?vue&type=script&setup=true&lang=js"

import "./VehicleRequest.vue?vue&type=style&index=0&id=98f84caa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98f84caa"]])

export default __exports__